import { INode, NodeType } from '@/api/nodes/mutations/directory/create-directory-mutation'

export function parseReadableNodeType(node: Pick<INode, 'type' | 'file'>) {
    const nodeType = node.type

    if (nodeType === NodeType.DIRECTORY) {
        return 'Folder'
    }

    if (nodeType === NodeType.FILE) {
        return node.file?.category.toLowerCase()
    }

    return 'Unknown'
}
